export default "__VITE_PUBLIC_ASSET__8dbde76b__"